'use strict';

module.exports = function replaceCharAt(str, index, replacement) {
  str = str.split('');
  str[index] = replacement;
  return str.join('');
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/replace-char-at.js
// module id = 1718
// module chunks = 0